import React from 'react';
import {connect} from 'react-redux';
import ProductPageBuyButtons from "../Components/ProductPageBuyButtons";
import {translate} from "../Services/translation";
import {RESELLER_FETCH_STATUSES} from "../Actions/ResellerGoogleMapProduct.action";

let ProductPageBuyButtonsContainer = function ({
    isMuurikka,
    isProductPage,
    status,
    productItem,
    productOnlineResellers,
    iconColor = 'white',
    openMiniCartAtCheckout = false
}) {
    let errorIconClass = `error-icon-${iconColor}`
    let noneFoundClass = productOnlineResellers.length ? '' : 'find-store--none-found';

    /**
     * @type {{icon: string, label: {string|JSX.Element}}}
     */
    let labelAndIcon = {
        label: translate('reseller.online.stores.fetching'),
        icon: '',
        stateClass: `find-store--${status}`,
        isLoading: status === RESELLER_FETCH_STATUSES.LOADING
    }

    switch (status) {
        case RESELLER_FETCH_STATUSES.FULFILLED:
            let textId = productOnlineResellers.length ?
                (isMuurikka ? 'reseller.stores.find' : 'buyorproductsonlineheader') :
                'reseller.online.stores.not.found';
            let iconClass = productOnlineResellers.length ? 'buy-icon' : errorIconClass;

            labelAndIcon.label = translate(textId);
            labelAndIcon.icon = <span className={iconClass}></span>;
            break;

        case RESELLER_FETCH_STATUSES.ERROR:
            labelAndIcon.label = translate('reseller.stores.fetching.error');
            labelAndIcon.icon = <span className={errorIconClass}></span>;
            break;

        case RESELLER_FETCH_STATUSES.LOADING:
            labelAndIcon.label = translate('reseller.online.stores.fetching');
            labelAndIcon.icon = <span className='reseller-stores-loading'><div></div></span>;
    }

    return <ProductPageBuyButtons {...{
        isMuurikka,
        isProductPage,
        status,
        labelAndIcon,
        productItem,
        productOnlineResellers,
        iconColor,
        noneFoundClass,
        openMiniCartAtCheckout
    }} />;
}

const mapStateToProps = state => {
    return {
        status: state.resellerProduct.status,
        productResellers: state.resellerProduct.productResellers,
        productOnlineResellers: state.resellerProduct.productOnlineResellers,
        resellerCountries: state.resellerProduct.resellerCountries,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPageBuyButtonsContainer);
